import { standardRubricFragment } from "AppComponents/StandardRubric/modules/StandardRubricFragments";
import {
  assessmentToolFragment,
  assessmentToolPlannerElementNodeFragment,
  mypObjectiveRubricDescriptorFragmnet,
} from "./AssessmentToolFragment";
import { gql } from "lib/apolloClient";

import { pypElementFragment } from "modules/CommonFragments";
import { gradeScaleToolFragment } from "AppComponents/AssessmentGradeScaleTool/modules/AssessmentGradeScaleToolFragments";

export const createMypObjectiveRubricMutation = gql`
  mutation createMypObjectiveRubric(
    $label: String
    $objectiveIds: [ID!]
    $parentId: ID!
    $parentType: ASSESSMENT_TOOL_PARENT_TYPE_ENUM!
    $toolType: ASSESSMENT_TOOL_TYPE_ENUM
  ) {
    planner {
      createMypObjectiveRubric(
        input: {
          parentId: $parentId
          parentType: $parentType
          label: $label
          objectiveIds: $objectiveIds
          toolType: $toolType
        }
      ) {
        ...mypObjectiveRubricItem
      }
    }
  }
  ${assessmentToolFragment.mypObjectiveRubric}
`;

export const createMypObjectiveRubricDescriptorsForObjectiveMutation = gql`
  mutation createMypObjectiveRubricDescriptorsForObjective(
    $objectiveIds: [ID!]
    $rubricId: ID!
  ) {
    planner {
      createMypObjectiveRubricDescriptorsForObjective(
        input: { rubricId: $rubricId, objectiveIds: $objectiveIds }
      ) {
        ...mypObjectiveRubricDescriptorItem
      }
    }
  }
  ${mypObjectiveRubricDescriptorFragmnet.mypObjectiveRubricDescriptor}
`;

export const deleteMypObjectiveRubricDescriptorsForObjectiveMutation = gql`
  mutation deleteMypObjectiveRubricDescriptorsForObjective(
    $objectiveIds: [ID!]
    $rubricId: ID!
  ) {
    planner {
      deleteMypObjectiveRubricDescriptorsForObjective(
        input: { rubricId: $rubricId, objectiveIds: $objectiveIds }
      ) {
        isSuccess
      }
    }
  }
`;

export const createExemplarMutation = gql`
  mutation createExemplar(
    $message: String!
    $createdBy: ID!
    $parentId: ID
    $parentType: ASSESSMENT_TOOL_PARENT_TYPE_ENUM
  ) {
    planner {
      createExemplar(
        input: {
          assessmentId: "DUMMY"
          message: $message
          createdBy: $createdBy
          parentId: $parentId
          parentType: $parentType
        }
      ) {
        ...exemplarItem
      }
    }
  }
  ${assessmentToolFragment.exemplar}
`;

export const updateExemplarMutation = gql`
  mutation updateExemplar($id: ID!, $message: String!, $updatedBy: ID!) {
    planner {
      updateExemplar(
        input: { id: $id, message: $message, updatedBy: $updatedBy }
      ) {
        id
      }
    }
  }
`;

export const createAnecdotalMutation = gql`
  mutation createAnecdote(
    $message: String
    $createdBy: ID!
    $parentId: ID
    $parentType: ASSESSMENT_TOOL_PARENT_TYPE_ENUM
  ) {
    planner {
      createAnecdote(
        input: {
          assessmentId: "DUMMY"
          message: $message
          createdBy: $createdBy
          parentId: $parentId
          parentType: $parentType
        }
      ) {
        ...anecdoteItem
      }
    }
  }
  ${assessmentToolFragment.anecdote}
`;

export const updateAnecdotalMutation = gql`
  mutation updateAnecdote($id: ID!, $message: String!, $updatedBy: ID!) {
    planner {
      updateAnecdote(
        input: { id: $id, message: $message, updatedBy: $updatedBy }
      ) {
        id
      }
    }
  }
`;

export const editMypObjectiveRubricDescriptorMutation = gql`
  mutation editMypObjectiveRubricDescriptor($id: ID!, $label: String) {
    planner {
      editMypObjectiveRubricDescriptor(input: { id: $id, label: $label }) {
        id
      }
    }
  }
`;

export const upsertDpAssessmentRubricV2Mutation = gql`
  mutation upsertDpAssessmentRubricsV2($input: [DpAssessmentRubricV2Input!]) {
    planner {
      upsertDpAssessmentRubricsV2(input: $input) {
        warning
        isSuccess
        response {
          ...mypObjectiveRubricItem
        }
      }
    }
  }
  ${assessmentToolFragment.mypObjectiveRubric}
`;

export const createCommentAssessmentToolMutation = gql`
  mutation createCommentAssessmentTool(
    $parentId: ID
    $parentType: ASSESSMENT_TOOL_PARENT_TYPE_ENUM
    $assessmentId: ID
  ) {
    planner {
      createCommentAssessmentTool(
        input: {
          parentId: $parentId
          parentType: $parentType
          assessmentId: $assessmentId
        }
      ) {
        response {
          id
        }
        warning
      }
    }
  }
`;

export const createScoreAssessmentToolMutation = gql`
  mutation createScoreAssessmentTool(
    $maxScore: ID
    $courseId: ID
    $categoryId: ID
    $templateId: String
    $parentId: ID
    $parentType: ASSESSMENT_TOOL_PARENT_TYPE_ENUM
    $assessmentId: ID
  ) {
    planner {
      createScoreAssessmentTool(
        input: {
          maxScore: $maxScore
          courseId: $courseId
          categoryId: $categoryId
          templateId: $templateId
          parentId: $parentId
          parentType: $parentType
          assessmentId: $assessmentId
        }
      ) {
        response {
          id
          scoreToolData {
            id
            maxScore
          }
        }
        warning
      }
    }
  }
`;

export const updateScoreToolDataMutation = gql`
  mutation updateScoreToolData($input: UpdateScoreToolDataInput) {
    planner {
      updateScoreToolData(input: $input) {
        response {
          id
          isCustomMaxScore
        }
        warning
      }
    }
  }
`;

export const createAssessmentGradeBoundaryMutation = gql`
  mutation createAssessmentGradeBoundaryMutation(
    $input: CreateAssessmentGradeBoundaryToolInput
  ) {
    planner {
      createAssessmentGradeBoundaryTool(input: $input) {
        response {
          ...ibGradeItem
        }
      }
    }
  }
  ${assessmentToolFragment.ibGrade}
`;

export const bulkEditMypObjectiveRubricDescriptorMutation = gql`
  mutation bulkEditMypObjectiveRubricDescriptor(
    $descriptors: [MypObjectiveRubricDescriptorUpdateInput!]!
  ) {
    planner {
      bulkEditMypObjectiveRubricDescriptor(input: $descriptors) {
        id
        label
      }
    }
  }
`;

export const reorderAssessmentToolItemMutation = gql`
  mutation reorderAssessmentToolItem($input: ReorderAssessmentToolItemInput!) {
    planner {
      reorderAssessmentToolItem(input: $input) {
        response
        warning
      }
    }
  }
`;

export const createAssessmentToolMutation = gql`
  mutation createAssessmentTool($input: CreateAssessmentToolInput) {
    planner {
      createAssessmentTool(input: $input) {
        response {
          id
          assessmentToolItem {
            ... on Analysis {
              id
            }
            ... on StandardRubric {
              ...standardRubricItem
            }
          }
        }
      }
    }
  }
  ${standardRubricFragment.standardRubric}
`;

export const updateAnalysisToolDetailsMutation = gql`
  mutation updateAnalysisToolDetails($input: UpdateAnalysisToolDetailsInput!) {
    planner {
      updateAnalysisToolDetails(input: $input) {
        warning
        isSuccess
      }
    }
  }
`;

export const deleteAssessmentToolMutation = gql`
  mutation deleteAssessmentTool($input: DeleteAssessmentToolInput!) {
    planner {
      deleteAssessmentTool(input: $input)
    }
  }
`;

export const updateAssessmentToolMutation = gql`
  mutation updateAssessmentTool($input: UpdateAssessmentToolInput) {
    planner {
      updateAssessmentTool(input: $input) {
        warning
        response {
          id
          assessmentToolItem {
            id
            ... on StandardRubric {
              id
              metadata
              associateScoreTool {
                id
                scoreToolData {
                  id
                  maxScore
                  isCustomMaxScore
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const bulkHandleAssessmentToolResponseMutation = gql`
  mutation bulkHandleAssessmentToolResponse(
    $input: [AssessmentToolResponseInput!]
  ) {
    planner {
      bulkHandleAssessmentToolResponse(input: $input) {
        isSuccess
        warning
        response {
          id
        }
      }
    }
  }
`;

export const convertRubricToScoreBasedRubricMutation = gql`
  mutation convertRubricToScoreBasedRubric(
    $input: convertRubricToScoreBasedRubricInput
  ) {
    planner {
      convertRubricToScoreBasedRubric(input: $input) {
        response {
          id
          assessmentToolItem {
            ... on StandardRubric {
              ...standardRubricItem
            }
          }
        }
        warning
      }
    }
  }
  ${standardRubricFragment.standardRubric}
`;

export const updateAssessmentForStandardBasedRubricMutation = gql`
  mutation updateAssessmentForStandardBasedRubric(
    $input: updateAssessmentInput
    $uids: [String!]
  ) {
    planner {
      updateAssessment(input: $input) {
        id
        fields(uids: $uids) {
          id
          value
          uid
          resolvedMinimalTree {
            id
            type
            ... on ResolvedFieldBenchmarkSet {
              id
              benchmarks {
                ...benchmarkItem
                gradingType
              }
            }
            ... on ResolvedFieldPlannerElementSet {
              id
              type
              nodes {
                ...assessmentToolPlannerElementNodeItem
                gradingType
                standardsWrapper {
                  standardSet {
                    id
                    title
                  }
                  properties {
                    isGradedStandard
                    tags {
                      id
                      label
                    }
                  }
                }
                plannerElementNodeWrapper {
                  properties {
                    isGradedStandard
                  }
                }
                parentData {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
  ${assessmentToolPlannerElementNodeFragment.plannerElementNode}
  ${pypElementFragment.benchmark}
`;

export const upsertGradeScaleToolMutation = gql`
  mutation upsertGradeScaleTool($input: UpsertGradeScaleToolInput) {
    planner {
      upsertGradeScaleTool(input: $input) {
        warning
        response {
          id
          assessmentToolItem {
            id
            ... on GradeScaleEntityDetail {
              ...gradeScaleEntityDetailsItem
            }
          }
        }
      }
    }
  }
  ${gradeScaleToolFragment.gradeScaleEntityDetails}
`;
